import { Component } from '@angular/core';

@Component({
  selector: 'event-skeleton',
  templateUrl: './event-skeleton.component.html',
  styleUrls: ['./event-skeleton.component.scss'],
})
export class EventSkeletonComponent {}
